import { render } from "./SoftwarePage.vue?vue&type=template&id=17ff702a"
import script from "./SoftwarePage.vue?vue&type=script&lang=js"
export * from "./SoftwarePage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__